<template>
  <iframe :src="'/static/pdfjs-3.2.146-dist/web/viewer.html?file=' + url"/>
</template>

<script>

export default {
  name: "FileView",
  props: {
    url: {
      type: String
    }
  },
  data() {
    return {
      show: {
        // 预览pdf
        previewPdfDialog: false,
      },
    }
  },
  methods: {
    previewPDF() {
    },
  },
}
</script>

<style scoped>

</style>